'use strict';

/* Directives */


angular.module('FlexyBeautyApp.directives')
    .directive('convertToNumber', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function(val) {
                    return '' + val;
                });
            }
        };
    })
    .directive('ngKeydown', function() {
        return {
            restrict: 'A',
            link: function(scope, elem, attrs) {
                // scope.dd.view.pTView next line will convert the string
                // function name into an actual function
                var functionToCall = scope.$eval(attrs.ngKeydown);
                var thisObjectName = attrs.ngKeydown.substr(0, attrs.ngKeydown.lastIndexOf('.'));
                var thisObject = null;
                if(thisObjectName)
                    thisObject = scope.$eval(thisObjectName);
                elem.on('keydown', function(e){
                    // on the keydown event, call my function
                    // and pass it the keycode of the key
                    // that was pressed
                    // ex: if ENTER was pressed, e.which == 13
                    if(functionToCall)
                        functionToCall(e, thisObject);
                });
            }
        };
    })
    .directive('uppercase', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                    if (!inputValue)
                        return "";
                    var capitalized = inputValue.toUpperCase();
                    if(capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                    return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]);  // capitalize initial value
            }
        };
    })
    .directive('noSpace', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var deleteSpace = function(inputValue) {
                    if (!inputValue)
                        return "";
                    var withoutSpace = inputValue.replace(" ","");

                    return withoutSpace;
                }
                modelCtrl.$parsers.push(deleteSpace);
                deleteSpace(scope[attrs.ngModel]);  // capitalize initial value
            }
        };
    })
    .directive('lowercase', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                    if (!inputValue)
                        return "";
                    var capitalized = inputValue.toLowerCase();
                    if(capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                    return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]);  // capitalize initial value
            }
        };
    })
    .directive('uppercaseFirstWord', function() {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, modelCtrl) {
            var capitalize = function(inputValue) {
                if (!inputValue)
                    return "";
                var index = inputValue.indexOf(" ");
                var capitalized = "";
                if (index!=-1)
                    if ((index+1)<inputValue.length)
                        capitalized = inputValue.substring(0,index+2).toUpperCase() + inputValue.substring(index+2).toLowerCase();//upper first letter of second word
                    else
                        capitalized = inputValue.substring(0,index+1).toUpperCase() + inputValue.substring(index+1).toLowerCase();
                else
                    capitalized = inputValue.toUpperCase();
                if(capitalized !== inputValue) {
                    modelCtrl.$setViewValue(capitalized);
                    modelCtrl.$render();
                }
                return capitalized;
            }
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]);  // capitalize initial value
        }
    };
})
    .directive('capitalizeWords', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                let el = element[0];

                function capitalize(inputValue) {
                    let capitalized = inputValue.toLowerCase();
                    capitalized = capitalized.replace(/(?:^|\s)\S/g, function (a) {
                        return a.toUpperCase();
                    });
                    return capitalized;
                }

                modelCtrl.$parsers.push(function (val) {
                    let capitalizedValue = capitalize(val);

                    if (capitalizedValue === val) return val;

                    let start = el.selectionStart;
                    let end = el.selectionEnd + capitalizedValue.length - val.length;

                    modelCtrl.$setViewValue(capitalizedValue);
                    modelCtrl.$render();

                    el.setSelectionRange(start, end);
                    return capitalizedValue;
                });
            }
        }
    })

    .directive('capitalizeFirstLetter', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var capitalize = function(inputValue) {
                    if (!inputValue ||inputValue.length == 0)
                        return "";
                    var capitalized = "";
                    if (inputValue.length>1)
                        capitalized = inputValue.charAt(0).toUpperCase() + inputValue.substring(1).toLowerCase();//upper first letter of second word
                    else
                        capitalized = inputValue.charAt(0).toUpperCase()
                    if(capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                    return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]);  // capitalize initial value
            }
        }
    })
    .directive('currencyFormat', ["$filter","$locale","CurrencyManager","NumberSeparatorType","$timeout", function($filter,$locale,CurrencyManager,NumberSeparatorType,$timeout) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, modelCtrl) {
                if (!modelCtrl) return;

                //whenever the bound ngModel expression changes programmatically
                //convert the $modelValue for display in the control (change the $viewValue)
                modelCtrl.$formatters.unshift(function (a) {
                    //we need to use parseFloat because "a" is a string witch contains a number
                    //and the filter currencyFormatFilter has an inapropriate behavior with this type of "string-number".
                    // The filter knows how to format :
                    // - number, like : 1000.00
                    // - number formatted string, like : 1 000,00
                    //but the currencyFormatFilter filter doesn't know how to format "1000.00"
                    return $filter('currencyFormatFilter')(parseFloat(a));
                });

                let timeoutCurrency = null;
                //call whenever the control updates the ngModelController with a new $viewValue from the DOM
                //convert the $viewValue (change the $modelValue)
                modelCtrl.$parsers.unshift(function (value) {
                    var newValue = null;
                    if (value != null && typeof value ==='string') {
                        newValue = CurrencyManager.getPriceFromPriceInput(value);
                    }
                    else{
                        newValue = value;
                    }
                    newValue = ((newValue + '').trim()) * 1;

                    if(timeoutCurrency)$timeout.cancel(timeoutCurrency);

                    timeoutCurrency = $timeout(function(){
                        //the user has change the viewValue but we want to add de curency sign
                        try {
                            modelCtrl.$setViewValue($filter('currencyFormatFilter')(newValue));
                        }
                        catch(e){
                            //when the user open quiclky the steps, there is sometimes an unknown exception in angular.
                            //the exception seems to be not "so important" and no best solution has been found
                            console.warn("Exception in AngularJs. No impact on the application is expected.")
                        }

                        modelCtrl.$render();
                    }, 2000);

                    return newValue;
                });
            }
        }
    }])
    .directive('numberFormat', ["$filter", function($filter) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, modelCtrl) {
                if (!modelCtrl) return;

                //whenever the bound ngModel expression changes programmatically
                //convert the $modelValue for display in the control (change the $viewValue)
                modelCtrl.$formatters.unshift(function (a) {
                    return $filter('number')(a, 2);
                });

                var timeout = null;
                //call whenever the control updates the ngModelController with a new $viewValue from the DOM
                //convert the $viewValue (change the $modelValue)
                modelCtrl.$parsers.unshift(function (value) {
                    var newValue = null;
                    if (value != null && typeof value ==='string') {
                        newValue = value.replace(",", ".").replace(" ", "");
                    }
                    else{
                        newValue = value;
                    }
                    newValue = ((newValue + '').trim()) * 1;

                    if(timeout)clearTimeout(timeout);

                    timeout = setTimeout(function(){
                        //the user has change the viewValue but we want to format it
                        modelCtrl.$setViewValue($filter('number')(newValue));
                        modelCtrl.$render();
                    }, 3000);

                    return newValue;
                });
            }
        }
    }])
    .directive('phoneInput', ["$document", "PhoneFormat", "$timeout", function($document, PhoneFormat, $timeout) {
        return {
            restrict: 'E',
            scope: {
                phone : "=phone",
                selectedCountry : "=selectedCountry",
                displayError : "=displayError",
                errorMessage : "=errorMessage",
                holderValue : "=holderValue",
                isMobile : "=isMobile"

            },
            templateUrl: '/partials/internationalisation/internationalPhoneFormat.html',
            controller: ['$scope', function($scope) {
                $scope.timeout = null;
                $scope.PhoneFormat = PhoneFormat;
                $scope.showFlagsList = false;
                $scope.isKeyDown = false;
                $scope.selectedTitle = "+33";
                $scope.setSelectedCountry = function(country, code){
                    $scope.selectedCountry = country;
                    $scope.selectedCode = code;

                    if(country == PhoneFormat.unknowFormat){
                        $scope.selectedTitle = 'Autre Pays';
                        $scope.displayError = false;
                    }
                    else if($scope.selectedCountry && $scope.phone && $scope.phone != "" && $scope.phone.length >= 4){
                        $scope.selectedTitle = country.toUpperCase() + " +" + code;
                        var oldCode = '';
                        var phone = '';
                        try{
                            oldCode = PhoneFormat.getPrefixNumber($scope.phone, country);
                            phone = $scope.phone.replace("+"+oldCode, "0");
                            $scope.phone = PhoneFormat.formatNumber(phone, $scope.selectedCountry);
                            $scope.displayError = !PhoneFormat.isValidNumberForRegion($scope.phone, $scope.selectedCountry);
                        }catch(e){
                            $scope.displayError = true;
                        }
                    }
                }

                $scope.getClassCssForFlag = function(){
                    var cssClass = '';
                    if($scope.selectedCountry != 'unknow' && PhoneFormat.isSupportedCountry($scope.selectedCountry))
                        cssClass += "iti-flag ";
                    else
                        cssClass += "fal fa-globe fa-lg ";
                    cssClass += $scope.selectedCountry;
                    return cssClass;
                }

                $scope.initField = function(){

                    var country = ''
                    var valueFormated = $scope.phone;
                    $scope.isKeyDown = false;
                    if(($scope.phone == null && !PhoneFormat.isSupportedCountry(PhoneFormat.getLocalCountry())) || ($scope.phone == '' && !PhoneFormat.isSupportedCountry(PhoneFormat.getLocalCountry())) || ($scope.phone && $scope.phone.length > 0 && $scope.phone.length < 4)){
                        var country =  PhoneFormat.unknowFormat;
                        $scope.selectedCountry = country;
                        $scope.selectedTitle = 'Autre Pays';
                        $scope.displayError = false;
                    }
                    else if($scope.phone && $scope.phone.length >= 4 && $scope.phone.indexOf("+") != -1)
                    {
                        var value = $scope.phone;
                        if(value){
                            country = PhoneFormat.getCountryFromNumber(value, $scope.isMobile);
                            if(country != PhoneFormat.unknowFormat){
                                valueFormated = PhoneFormat.formatNumber(value, country);
                                var code = PhoneFormat.getPrefixNumber(value, country);
                                $scope.selectedCountry = country.toLowerCase();
                                $scope.selectedTitle = country.toUpperCase() + " +" + code;
                            }
                        }
                    }
                    else if($scope.phone && $scope.phone.length >= 4 && $scope.phone.indexOf("+") == -1){
                        valueFormated = PhoneFormat.formatNumberWithoutCountry($scope.phone, $scope.isMobile);
                        country = PhoneFormat.getCountryFromNumber(valueFormated, $scope.isMobile);
                        var code = PhoneFormat.getPrefixNumber(valueFormated, country);
                        $scope.selectedCountry = country.toLowerCase();
                        $scope.selectedTitle = (country != PhoneFormat.unknowFormat ? country.toUpperCase() + " +" + code : code);
                    }
                    else{
                        var country = PhoneFormat.getLocalCountry();
                        $scope.selectedCountry = country;
                        $scope.selectedTitle = country.toUpperCase();
                    }
                    if(country != 'unknow')
                        $scope.phone = valueFormated;
                }

                $scope.onInputKeyDown = function(){
                    $scope.isKeyDown = true;
                }

                $scope.onInputKeyUp = function(e){
                    $scope.isKeyDown = false;
                }

                $scope.$watch('selectedCountry', function (selectedCountry) {
                    if(selectedCountry && $scope.phone)
                        $scope.setSelectedCountry(selectedCountry, PhoneFormat.getPrefixNumber($scope.phone, selectedCountry));
                    else if(!selectedCountry && $scope.phone){
                        var country = PhoneFormat.getCountryFromNumber($scope.phone, $scope.isMobile);
                        if(country){
                            country = country.toLowerCase();
                            $scope.setSelectedCountry(country, PhoneFormat.getPrefixNumber($scope.phone, country));
                        }
                    }
                    else if(!selectedCountry && !$scope.phone){
                        $scope.setSelectedCountry(PhoneFormat.getLocalCountry(), '');
                    }
                });

                $scope.$watch('phone', function (phone) {
                    if($scope.selectedCountry && $scope.selectedCountry == PhoneFormat.getLocalCountry() && !PhoneFormat.isSupportedCountry(PhoneFormat.getLocalCountry()))
                    {
                        $scope.selectedCountry = PhoneFormat.unknowFormat;
                        $scope.selectedTitle = 'Autre Pays';
                    }
                    if($scope.selectedCountry == 'unknow'){
                    if(phone == null || phone == '' || PhoneFormat.isValidDigitNumber(phone))
                        $scope.displayError = false;
                    else
                        $scope.displayError = true;
                    }
                    else if (phone){
                        var valueFormated;
                        var country = $scope.selectedCountry;
                        try{

                            if($scope.phone && $scope.phone.length >= 4){
                                if ($scope.timeout)
                                    $timeout.cancel($scope.timeout);
                                $scope.timeout = $timeout(function() {
                                    if(!$scope.isKeyDown){
                                        valueFormated = PhoneFormat.formatNumber($scope.phone, country);
                                        if(valueFormated != $scope.phone)
                                            $scope.phone = valueFormated;
                                    }
                                }, 800);
                            }
                            if($scope.isMobile){
                                $scope.displayError = !PhoneFormat.isMobileNumber($scope.phone, $scope.selectedCountry);
                            }
                            else{
                                $scope.displayError = !PhoneFormat.isValidNumberForRegion($scope.phone, $scope.selectedCountry);
                            }
                        }
                        catch(error){
                            $scope.displayError = true;
                        }
                    }
                    else{
                        $scope.displayError = false;
                    }

                });
                $scope.initField();
            }]
        }
    }]);





// WEBPACK FOOTER //
// ./js/directives/directivesCommon.js